import { useState, useEffect, useCallback } from "react";
import api from "../utils/api"; // 🔥 ekledik

export function useSocialMediaData(channelId, mode, startDate, endDate, refreshKey = 0, ytChannelId = null) {
  const [youtubeData, setYoutubeData] = useState(null);
  const [twitterData, setTwitterData] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadYoutube = useCallback(async () => {
    try {
      // 1. try with own channelId first
      const res = await api.get(
        `/yt?c=${channelId}&mode=${mode}&start=${startDate}&end=${endDate}`
      );
      const data = res.data;
      const hasData = data && typeof data === "object" && Object.keys(data).length > 0;

      if (hasData) {
        setYoutubeData(data);
        return;
      }

      // 2. no data — fallback to ytChannelId if different
      if (ytChannelId && ytChannelId !== channelId) {
        const fallback = await api.get(
          `/yt?c=${ytChannelId}&mode=${mode}&start=${startDate}&end=${endDate}`
        );
        setYoutubeData(fallback.data);
      } else {
        setYoutubeData(data);
      }
    } catch (err) {
      console.error("YouTube fetch error:", err);
    }
  }, [channelId, ytChannelId, mode, startDate, endDate]);

  const loadTwitter = useCallback(async () => {
    try {
      const res = await api.get(
        `/x?c=${channelId}&mode=${mode}&start=${startDate}&end=${endDate}`
      );
      setTwitterData(res.data);
    } catch (err) {
      console.error("Twitter fetch error:", err);
    }
  }, [channelId, mode, startDate, endDate]);

  useEffect(() => {
    if (!channelId) return;

    async function loadAll() {
      setLoading(true);

      await Promise.all([
        loadYoutube(),
        loadTwitter(),
      ]);

      setLoading(false);
    }

    loadAll();
  }, [loadYoutube, loadTwitter, refreshKey, channelId]);

  return { youtubeData, twitterData, loading };
}